import { useState, useEffect, Key } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/ScmTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { globalPrompt } from "@/components/message";
import { IMaterialDetail, IMaterialSearchFields, materialService } from "../../../../base/material/materialService"
import { IPurchaseApprovalFields, IDetailList } from "../../purchaseApprovalType"
import { purchaseApprovalService } from "../../purchaseApprovalService"
import { transPgToPagination, formatNum, IsUseDefaultBentity, momentFormat } from "@/utils/utils";
import useGlobalModel from "@/model/globalModel";
import { IVRMshelfDetail } from "@/views/base/warehouse/warehouseTypes";
import { convertRes2Blob } from "@/utils/exportFile";
import { DictCodeEnmu, sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import { IStockStatisticDetail } from "@/views/stock/statistic/stockStatisticService";
import { useLockFn } from "ahooks";
import { message } from "antd";
import moment from "moment";

export const usePurchaseApprovalDetailsModel = createModel(function () {
    const { user, shopAndOrg, beShopDs } = useGlobalModel()
    const { shopId, shopName, shopCode } = shopAndOrg
    const [addModalVisible, setAddModalVisible] = useState<boolean>(false)  //新增商品弹框
    const initForm = {
        shopId, shopName,
        bentityName: beShopDs.find((item: any) => item.value === "bentity.hd")?.label ?? "",
        bentityCode: "bentity.hd",
        orgCode: user.userOrgCode,
        orgName: user.userOrgName,
        createUser: user.userName,
        isDirect: 0
    }
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initSearchParam: IMaterialSearchFields = {};
    //新增数据
    //新增详情form
    const [detailAddForm, setDetailAddForm] = useState<IPurchaseApprovalFields>({ initForm })
    //新增详情列表
    const [detailAddList, setDetailAddList] = useState<IDetailList[]>([])
    //新增详情列表选中行
    const [detaiAddDataRowKeys, setDetaiAddDataRowKeys] = useState<Key[]>([]);
    const [detaiAddDataRow, setDetaiAddDataRow] = useState<IDetailList[]>([]);

    //查看数据
    //查看详情form
    const [detailLookForm, setDetailLookForm] = useState<IPurchaseApprovalFields>({})
    //查看详情列表
    const [detailLookList, setDetailLookList] = useState<IDetailList[]>([])

    //详情数据
    //详情列表参数
    const [detailDataSource, setDetailDataSource] = useState<IDetailList[]>([]);
    //详情表格选中行
    const [detailDataRowKeys, setDetailDataRowKeys] = useState<Key[]>([]);
    const [detailDataRow, setDetailDataRow] = useState<IDetailList[]>([]);
    const [detailEditForm, setDetailEditForm] = useState<IPurchaseApprovalFields>({})

    //配件列表配置
    const [workDataSource, setWorkDataSource] = useState<any[]>([])
    const [searchWorkData, setSearchWorkData] = useState<IMaterialSearchFields>(initSearchParam)
    const [workPgCfg, setWorkPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //已选配件列表
    const [addDataSource, setAddDataSource] = useState<any[]>([]);
    const [saveLoading, setSaveLoading] = useState<boolean>(false); //  保存按钮
    //表单改变或表格数据发生改变时，控制功能按钮的启用禁用
    const [topButsControl, setTopButsControl] = useState<boolean>(false)
    const typeForm: any = {
        add: { ...detailAddForm, shopId, shopCode, shopName },
        edit: detailEditForm,
        look: detailLookForm
    }
    //新增表单缓存
    const updateAddFormVal = (val: IPurchaseApprovalFields) => {
        let newVal = val
        setDetailAddForm({ ...detailAddForm, ...newVal })
    }
    //编辑表单缓存
    const updatEditFormVal = (val: IPurchaseApprovalFields) => {
        let newVal = val
        setDetailEditForm({ ...detailEditForm, ...newVal })
    }
    useEffect(() => {
        setDetailAddForm({ ...initForm, shopId, shopName });
    }, [shopId])
    //获取一条编辑或查看数据
    const getDetailEditOne = async (id: string, pattern: string) => {
        let { retData } = await purchaseApprovalService.one(id);
        const { details, ...from } = retData
        if (retData) {
            let fileList: any = []
            const { md5, fileName } = from
            if (md5) {
                fileList = [
                    {
                        uid: md5,
                        status: 'done',
                        name: fileName,
                        response: {
                            retData: md5,
                        },
                    },
                ]
            }
            from.fileList = fileList
            if (pattern === "edit") {
                setDetailDataSource(details as IDetailList[] ?? [])
                setDetailEditForm({
                    ...from,
                    createTimes: from.createTime ? momentFormat(from.createTime) : null,
                    approvalTimes: from.approvalTime ? momentFormat(from.approvalTime) : null,
                })
                setTopButsControl(false)
            } else if (pattern === "look") {
                setDetailLookForm(from);
                setDetailLookList(details as IDetailList[] ?? [])
            }
        }
    }
    //关闭弹框
    const resetWorkloadData = async () => {
        setSearchWorkData({});
        workloadData(initPgCfg, {});
    }
    const [addLoading, setAddLoading] = useState<boolean>(false)
    //加载配件数据
    const workloadData = async (page?: ISearchPage, searchValue: IMaterialSearchFields = searchWorkData) => {
        setAddLoading(true)
        const searchParams = {
            ...searchValue,
            ...shopAndOrg,
            ...sourceAppOrBranch,
            pageSize: page?.pageSize ?? workPgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? workPgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await materialService.page(searchParams);
        const { records, ...pg } = retData;
        const newRecords = records.map(item => {
            let { latestPurPrice, materialDetal, materialShelfVo } = item
            let materialOne = (materialDetal ?? [])[0]
            materialShelfVo = materialShelfVo ?? {}
            //取最近采购价格，没有的话取档案进货价
            let purchasePrice = !!latestPurPrice ? latestPurPrice : materialOne?.purchasePrice ?? 0;
            return {
                ...item,
                num: 1,
            }
        })
        setWorkPgCfg(transPgToPagination(pg));
        setWorkDataSource(newRecords);
        setAddLoading(false)
    }
    //筛选模块详情 详情和新增的列表已有数据的方法
    const modelScreenMethod = async (modelList: any[], detailList: IDetailList[], mode: string) => {
        console.log(modelList, detailList)
        const repetition: string[] = [];
        const newDetailData: any[] = [...detailList]
        modelList.forEach(Item => {
            let isSelect = newDetailData.find(item => item.materialCode === (Item.materialCode ?? Item.code));
            if (isSelect === undefined) {
                newDetailData.push({
                    // ...Item,
                    id: "",
                    materialCode: Item.materialCode ?? Item.code,
                    materialName: Item.materialName ?? Item.name,
                    brandName: Item.brandName,
                    brandCode: Item.brandCode,
                    vehicleModel: Item.vehicleModel,
                    upperClothBrand: Item.upperClothBrand,
                    chassisBrand: Item.chassisBrand,
                    model: Item.model,
                    unitCode: Item.unitCode,
                    unitName: Item.unitName,
                    purpose: '',
                    note: Item.note,
                    initNum: mode == 'add' || typeForm[mode].status === "purchase_approval.init" ? Item.num : 0,
                    confirmNum: Item.num,
                });
            } else {
                repetition.push(`【${Item.materialName ?? Item.name} (${Item.materialCode ?? Item.code})】`);
            }
        })
        return { newDetailData, repetition }
    }
    //添加到详情列表
    const transformsToPoDetailList = async (mode: string) => {
        //添加列表
        if (mode === "add") {
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailAddList, mode)
            setDetailAddList([...newDetailData])
            repetition.length != 0 && globalPrompt("message", { text: `${repetition.join(",")}，以上重复配件已过滤。`, type: "warning" });
            setTopButsControl(true)
        } else if (mode === "edit") {
            //详情列表
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailDataSource, mode)
            setDetailDataSource([...newDetailData])
            repetition.length != 0 && globalPrompt("message", { text: `${repetition.join(",")}，以上重复配件已过滤。`, type: "warning" });
            setTopButsControl(true)
        }
    }
    //删除详情列表数据
    const detailDetailList = async (mode: string, Material?: IDetailList) => {
        let newData = mode === "edit" ? detailDataSource : detailAddList;
        let newRowKeys = mode === 'add' ? detaiAddDataRowKeys : detailDataRowKeys
        const filterDetailList = Material ? newData.filter(el => !!!(Material.materialCode === el.materialCode)) : newData.filter(el => !!!newRowKeys.find(ele => ele === el.materialCode));
        mode === "edit" ? setDetailDataSource([...filterDetailList]) : setDetailAddList([...filterDetailList])
        globalPrompt("message", { text: `删除成功`, type: "success" });
        setDetaiAddDataRowKeys([]);
        setDetaiAddDataRow([]);
        setTopButsControl(true)
    }
    //新增采购单
    const insertDetail = useLockFn(async (params: IPurchaseApprovalFields) => {
        try {
            let newParams = {
                ...params,
                details: detailAddList,
                createUser: user.username,
                // ...shopAndOrg,
                ...sourceAppOrBranch,
            }
            setSaveLoading(true)
            let { retData } = await purchaseApprovalService.insert(newParams);
            setSaveLoading(false)
            return retData;
        } catch (error) {
            setSaveLoading(false)
        }
    })
    //编辑采购单
    const editDetail = useLockFn(async (params: IPurchaseApprovalFields) => {
        try {
            let newParams = {
                ...params,
                details: detailDataSource,
                updateUser: user.username,
                // ...shopAndOrg,
                ...sourceAppOrBranch,
            }
            setSaveLoading(true)
            let { retData } = await purchaseApprovalService.update(newParams);
            setSaveLoading(false)
            return retData;
        } catch (error) {
            setSaveLoading(false)
        }
    })
    //关闭页签清不同状态缓存
    const resetAddCatch = async (type: string) => {
        setDetailAddForm({ ...initForm, shopId, shopName });
        setDetailAddList([]);
    }
    const resetEditCatch = async (type: string) => {
        setDetailEditForm({});
        setDetailDataSource([]);
    }
    const downloadTpl = async () => {
        let result = await purchaseApprovalService.downloadTpl();
        convertRes2Blob(result)
    }
    const Submit = useLockFn(async () => {
        let { retData } = await purchaseApprovalService.submit(detailEditForm.id as string);
        return retData
    })
    const onTranfer = useLockFn(async () => {
        let { retData } = await purchaseApprovalService.onTranfer(detailEditForm.id as string);
        return retData
    })
    const Transfer = useLockFn(async (val) => {
        let { retData } = await purchaseApprovalService.transfer({
            id: detailEditForm.id,
            status: val
        });
        return retData
    })
    const [historyVisible, setHistoryVisible] = useState<boolean>(false)
    const [historyRow, setHistoryRow] = useState<IStockStatisticDetail>({})
    const [supplierHistoryVisible, setSupplierHistoryVisible] = useState<boolean>(false) //消费记录展示
    const [supplierHistoryModel, setSupplierHistoryModel] = useState<{ supplierName: string }>({ supplierName: "" }) //消费记录参数
    return {
        addModalVisible, addLoading,
        initPgCfg,
        detailAddForm,
        detailAddList,
        detaiAddDataRow,
        detailLookForm,
        detailLookList,
        detailDataSource,
        detailDataRowKeys,
        detailDataRow,
        detailEditForm,
        workDataSource,
        searchWorkData,
        workPgCfg,
        addDataSource,
        detaiAddDataRowKeys,
        setAddModalVisible,
        setDetailAddForm,
        setDetailAddList,
        setDetaiAddDataRow,
        setDetailLookForm,
        setDetailLookList,
        setDetailDataSource,
        setDetailDataRowKeys,
        setDetailDataRow,
        setDetailEditForm,
        setWorkDataSource,
        setSearchWorkData,
        setWorkPgCfg,
        setAddDataSource,
        updateAddFormVal,
        updatEditFormVal,
        getDetailEditOne,
        resetWorkloadData,
        workloadData,
        transformsToPoDetailList,
        detailDetailList,
        insertDetail,
        editDetail,
        resetAddCatch,
        resetEditCatch,
        setDetaiAddDataRowKeys,
        downloadTpl,
        modelScreenMethod,
        Transfer,
        Submit,
        onTranfer,
        initForm,
        topButsControl, setTopButsControl,
        historyVisible, setHistoryVisible,
        historyRow, setHistoryRow,
        supplierHistoryVisible, setSupplierHistoryVisible,
        supplierHistoryModel, setSupplierHistoryModel,
        saveLoading, setSaveLoading
    }
})